import { ThemeOptions } from '@mui/material/styles';

export const typographyBaseTheme: ThemeOptions = {
  typography: {
    fontFamily:
      '"Satoshi", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.625rem',
      fontWeight: 500,
      lineHeight: '3rem',
      letterSpacing: '-0.0525rem',
      textTransform: 'unset',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      lineHeight: '2.5rem',
      letterSpacing: '-0.04rem',
      textTransform: 'unset',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: '2.25rem',
      letterSpacing: '-0.035rem',
      textTransform: 'unset',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: '2rem',
      letterSpacing: '-0.03rem',
      textTransform: 'unset',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: '1.75rem',
      letterSpacing: '-0.03rem',
      textTransform: 'unset',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: '1.75rem',
      letterSpacing: '-0.025rem',
      textTransform: 'unset',
    },
    h7: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: '0.875rem',
      letterSpacing: '0.09rem',
      textTransform: 'uppercase',
    },
    p1: {
      fontSize: '1rem',
      lineHeight: '1.375rem',
      fontWeight: 700,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p2: {
      fontSize: '1rem',
      lineHeight: '1.375rem',
      fontWeight: 500,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p3: {
      fontSize: '1rem',
      lineHeight: '1.375rem',
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p4: {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 500,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p5: {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p6: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 700,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p7: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 500,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p8: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p9: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      fontWeight: 500,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    p10: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    button1: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 700,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    button2: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 500,
      letterSpacing: 0,
      textTransform: 'unset',
    },
    button3: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 500,
      letterSpacing: 0,
      textDecoration: 'underline',
      textTransform: 'unset',
      textUnderlinePosition: 'from-font',
    },
    error: {
      fontSize: '0.875rem',
      fontWeight: 700,
      color: 'red',
    },
  },
};
